<template>
  <div>
    <protocol-header v-if="protocol && !readonly"
                     :protocol="protocol"
                     :task="task"></protocol-header>
    
    <amendment-header v-if="amendment && !readonly"
                      :amendment="amendment"></amendment-header>
    
    <div class="row">
      <div class="col-12">
        <div class="card-header">
          <h1 class="card-title mb-0">{{ task.classification.title }}</h1>
        </div>
        
        <div class="card">
          <div class="card-body">
            <div class="nav-scroller border-bottom">
              <div class="nav nav-tabs">
                <a class="nav-link active" href="#amendment-data" data-toggle="tab">Datos de enmienda</a>
                <a class="nav-link" href="#attachments" data-toggle="tab">
                  <span v-if="!readonly">Incorporar anexos a la solicitud</span>
                  <span v-else>Anexos de la enmienda</span>
                </a>
              </div>
            </div>
            
            <div class="tab-content pt-4">
              <div class="tab-pane fade show active" id="amendment-data" role="tabpanel">
                <div class="financing-information" v-show="showFinancing">
                  <button class="btn btn-outline-primary btn-lg mb-4 no-readonly" @click="showFinancing = !showFinancing">Ver datos
                                                                                                              de
                                                                                                              enmienda
                  </button>
                  
                  <amendment-financing :amendment="amendment"
                                       v-if="amendment"
                                       :editable="!readonly"
                                       :editable-commitments="true"
                                       @saved-financing-information="shadvancesowFinancing = !showFinancing"></amendment-financing>
                </div>
                
                <form method="post" onsubmit="return false" ref="form"
                      v-if="amendment && !showFinancing">
                  
                  <div class="form-group">
                    <label class="d-block font-weight-normal"
                           for="justification">Fecha de término real:
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    <strong>{{ formatDate(protocol.real_end_date) }}</strong>
                  </div>
                  
                  <div class="form-group">
                    <label class="d-block font-weight-normal"
                           for="end_Date">Fecha de término solicitada:
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    
                    <input type="date"
                           name="end_date"
                           id="end_date"
                           class="form-control no-readonly"
                           v-if="amendment.status.key === 'enviada' || amendment.status.key === 'condicionada'"
                           v-model="amendmentEndDate"/>
                    
                    <input type="date"
                           name="end_date_readonly"
                           id="end_date_readonly"
                           class="form-control"
                           v-else
                           v-model="amendmentEndDate"/>
                    
                    <button type="button" class="btn btn-primary btn-sm d-block mt-2 no-readonly"
                            v-if="amendment.status.key === 'enviada' || amendment.status.key === 'condicionada'"
                            :disabled="updatingDate"
                            @click="updateEndDate">
                      <spinner small class="text-white" v-if="updatingDate"></spinner>
                      Actualizar fecha
                    </button>
                  </div>
                  
                  <div class="form-group">
                    <label class="d-block font-weight-normal"
                           for="justification">Explique en que consiste la enmienda al protocolo:
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    <textarea name="justification"
                              id="justification"
                              placeholder="¿En qué consiste la enmienda al protocolo?"
                              class="form-control"
                              rows="5"
                              cols="5"
                              v-model="amendment.justification"></textarea>
                  </div>
                  
                  <div class="form-group">
                    <label class="d-block font-weight-normal">¿La enmienda contempla nuevo financiamiento?
                      <abbr style="text-decoration: none;"
                            title="Campo obligatorio">*</abbr>
                    </label>
                    <div class="form-row">
                      <div class="col d-flex">
                        <div class="custom-control custom-radio mr-3 d-flex align-items-center">
                          <input type="radio"
                                 class="custom-control-input"
                                 name="new_financing"
                                 id="new_financing_yes"
                                 :value="true"
                                 v-model="amendment.new_financing">
                          <label class="custom-control-label" for="new_financing_yes">Si</label>
                        </div>
                        <div class="custom-control custom-radio d-flex align-items-center">
                          <input type="radio"
                                 class="custom-control-input"
                                 name="new_financing"
                                 id="new_financing_no"
                                 :value="false"
                                 v-model="amendment.new_financing">
                          <label class="custom-control-label" for="new_financing_no">No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div v-if="amendment.new_financing">
                    <p class="alert alert-danger text-center">Registre el nuevo financiamiento antes de enviar la enmienda a revisión</p>
                  </div>
                  
                  <div class="form-group" v-if="(!readonly || evaluating) && amendment.new_financing">
                    <a href="#" class="btn btn-lg btn-outline-primary"
                       @click.prevent="showFinancing = !showFinancing">
                      {{
                      amendment.has_financing_information
                      ? 'Ver nuevo financiamiento'
                      : 'Registrar nuevo financiamiento'
                      }}
                    </a>
                  </div>
                  
                  <div class="d-flex" v-if="!readonly">
                    <button type="button"
                            class="btn btn-primary btn-lg mr-3"
                            @click.prevent="saveAmendment"
                            :disabled="saving">
                      <spinner small class="text-white" v-if="saving"></spinner>
                      {{ amendment ? 'Actualizar' : 'Guardar' }}
                    </button>
                    
                    <button type="button"
                            class="btn btn-dark btn-lg"
                            v-if="amendment.updated"
                            :disabled="saving"
                            data-toggle="modal"
                            data-target="#send-amendment-modal">
                      <i class="fas fa-paper-plane mr-2"></i> Enviar enmienda a revisión
                    </button>
                    
                    <button type="button"
                            class="btn btn-danger btn-lg ml-auto"
                            :disabled="saving"
                            data-toggle="modal"
                            data-target="#delete-amendment-modal">Eliminar
                    </button>
                  </div>
                </form>
                <template v-if="dictums.length > 0">
                  <hr class="mt-4 mb-4" />
                  <div>
                    <h6 class="mb-3">Historial de justificaciones:</h6>
                    <div class="table-responsive">
                      <dynamic-table
                        :columns="columns"
                        :data="dictums"
                        :loading="loading"
                        class="table-hover"
                        theadClass="thead-light"
                        empty-message="No existen justificaciones registradas"
                      >
                        <template v-slot:type.title="slotProps">
                          <span v-if="slotProps.row.type.title === 'Aprobado'"
                              class="badge badge-success">{{ slotProps.row.type.title }}</span>
                          <span
                              v-else-if="slotProps.row.type.title === 'No aprobado' || slotProps.row.type.title === 'Rechazado'"
                              class="badge badge-subtle badge-danger">{{ slotProps.row.type.title }}</span>
                          <span v-else
                              class="badge badge-subtle badge-dark">{{ slotProps.row.type.title }}</span>
                        </template>
                        <template v-slot:comments="slotProps">
                          <button
                            @click.prevent="showMessageModal(slotProps.row.comments, 'Comentarios del dictamen.')"
                            v-if="slotProps.row.comments"
                            class="btn btn-sm btn-outline-primary d-block"
                            style="white-space: nowrap"
                          >
                            Ver comentarios
                          </button>
                          <p v-else>
                            Sin comentarios.
                          </p>
                        </template>
                        <template v-slot:justification="slotProps">
                          <button
                            @click.prevent="showMessageModal(slotProps.row.justification, 'Justificación del dictamen.')"
                            v-if="slotProps.row.justification"
                            class="btn btn-sm btn-outline-primary d-block"
                            style="white-space: nowrap"
                          >
                            Ver justificación
                          </button>
                          <p v-else>
                            Sin justificación.
                          </p>
                        </template>
                      </dynamic-table>
                    </div>
                  </div>
                </template>
              </div>
              
              <div class="tab-pane fade" id="attachments" role="tabpanel">
                <div class="page-section">
                  <div class="section-block m-0 p-0">
                    <div class="row">
                      <div class="col">
                        <p class="font-weight-bold mt-3"
                           v-if="amendment && amendment.attachments && amendment.attachments.length">
                          Anexos agregados
                        </p>
                        
                        <files-list v-if="selectedAmendment"
                                    :model="selectedAmendment"
                                    :files="selectedAmendment.attachments"
                                    :save-files-function="saveAttachments"
                                    @delete-file="deleteAttachment"
                                    :readonly="readonlyFiles"></files-list>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <portal to="task-modals">
        <ok-cancel-dialog title="Eliminar enmienda"
                          id="delete-amendment-modal"
                          ref="delete-amendment-modal"
                          content="<p>¿Esta seguro eliminar la enmienda?</p>"
                          ok-button-text="Confirmar"
                          :ok-callback="deleteAmendment"></ok-cancel-dialog>
        
        <ok-cancel-dialog title="Enviar enmienda a revisión"
                          id="send-amendment-modal"
                          ref="send-amendment-modal"
                          content="<p>¿Esta seguro de enviar la enmienda a revisón?</p>"
                          ok-button-text="Confirmar"
                          :ok-callback="sendAmendmentToEvaluation"></ok-cancel-dialog>
        
        <file-modal id="file-modal"
                    multiple
                    title="Adjuntar anexos"
                    :save-files-function="saveAttachments"></file-modal>
        
        <message-modal id="amednment-extension-message-modal"
                       ref="amednmentExtensionMessageModal"
                       :title="modalTitle"
                       :message="modalMessage"></message-modal>
      </portal>
    </div>
  </div>
</template>
<script>
  import autosize from 'autosize'
  import 'jquery-validation'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import Spinner from '../ui/Spinner'
  import ProtocolHeader from '../protocols/ProtocolHeader'
  import AmendmentHeader from './AmendmentHeader'
  import FileModal from '../ui/FileModal'
  import FilesList from '../protocols/FilesList'
  import AmendmentFinancing from '../protocols/AmendmentFinancing'
  import moment from 'moment'
  import DynamicTable from "../ui/DynamicTable";
  import MessageModal from '../ui/MessageModal'
  import 'flatpickr'
  import 'flatpickr/dist/flatpickr.min.css'
  import { Spanish } from 'flatpickr/dist/l10n/es'
  
  export default {
    name: 'AmendmentExtension',
    components: {
      OkCancelDialog,
      ProtocolHeader,
      AmendmentHeader,
      Spinner,
      FileModal,
      FilesList,
      AmendmentFinancing,
      DynamicTable,
      MessageModal,
    },
    props: {
      user: Object,
      protocol: Object,
      task: Object,
      amendment: Object,
      committee: Object,
      readonly: {
        type: Boolean,
        default: false,
      },
      readonlyFiles: {
        type: Boolean,
        default: false,
      },
      evaluating: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        editing: false,
        saving: false,
        updatingDate: false,
        showFinancing: false,
        amendmentEndDate: null,
        loading: false,
        dictums: [],
        modalTitle: null,
        modalMessage: null,
        columns: [
          {
            field: "committee.name",
            title: "Comité",
            tdClass: "text-left text-truncate",
            tdStyle: {},
            thClass: "align-middle",
            thStyle: {},
            width: "200",
          },
          {
            field: "type.title",
            title: "Dictamen",
            tdClass: "text-left text-truncate",
            tdStyle: {},
            thClass: "align-middle",
            thStyle: {},
            width: "200",
          },
          {
            field: "dictum_date",
            title: "Fecha dictamen",
            tdClass: "text-left text-truncate",
            tdStyle: {},
            thClass: "align-middle",
            thStyle: {},
            width: "200",
          },
          {
            field: "comments",
            title: "Comentarios",
            tdClass: "text-left text-truncate",
            tdStyle: {},
            thClass: "align-middle",
            thStyle: {},
            width: "200",
          },
          {
            field: "justification",
            title: "Justificacion",
            tdClass: "text-left text-truncate",
            tdStyle: {},
            thClass: "align-middle",
            thStyle: {},
            width: "200",
          },
        ]
      }
    },
    methods: {
      ...mapActions({
        saveProtocolAmendment: 'amendments/saveAmendment',
        saveAmendmentAttachments: 'amendments/saveAttachments',
        deleteProtocolAmendment: 'amendments/deleteAmendment',
        removeAttachmentFromAmendment: 'amendments/removeAmendmentAttachment',
        sendAmendment: 'amendments/sendAmendmentToEvaluation',
        updateAmendmentEndDate: 'amendments/updateAmendmentEndDate',
        getAmendmentDictums: 'amendments/getDictums',
        getFunders: 'amendments/getAmendmentFunders',
        getFinancingCommitments: 'amendments/getFinancingCommitments',
      }),
      
      ...mapMutations({
        setAmendment: 'amendments/SET_AMENDMENT',
      }),
      
      async updateEndDate () {
        this.updatingDate = true
        
        const response = await this.updateAmendmentEndDate({ amendment: this.amendment })
        
        this.updatingDate = false
        
        const {
                status,
                error,
                message,
              } = response
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        AlertManager.success(message)
      },
      
      async saveAmendment () {
        if (!$(this.$refs.form).valid()) {
          return false
        }
        
        this.saving = true
        
        const {
                end_date,
                new_financing,
                justification,
                type,
              } = this.amendment
        
        const response = await this.saveProtocolAmendment({
          amendment: this.amendment,
          justification,
          end_date,
          new_financing,
          type,
        })
        
        this.saving = false
        
        const {
                error,
                status,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return
        }
        
        // Update updated flag.
        this.amendment.updated = true

        // Update financing information
        await this.getFunders(this.amendment)
        await this.getFinancingCommitments(this.amendment)
        
        AlertManager.success(message)
      },
      async saveAttachments (files) {
        const formData = new FormData()
        
        files.forEach(file => {
          formData.append('files[]', file.file)
        })
        
        formData.append('amendment', this.amendment.id)
        formData.append('type', this.amendment.type.key)
        
        const response = await this.saveAmendmentAttachments(formData)
        
        const {
                status,
                error,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        $(`#attachments-modal`).modal('hide')
      },
      async deleteAttachment (file, callback) {
        const response = await this.removeAttachmentFromAmendment({
          amendment: this.amendment,
          file,
        })
        
        if (response.status === 'success') {
          AlertManager.success(response.message)
        }
        else {
          AlertManager.error(response.error)
        }
        
        callback(response)
      },
      async deleteAmendment () {
        this.saving = true
        
        const response = await this.deleteProtocolAmendment({
          amendment: this.amendment,
        })
        
        this.saving = false
        
        const {
                status,
                error,
                message,
              } = response.data.data
        
        if (status === 'error') {
          AlertManager.error(error)
          
          return false
        }
        
        AlertManager.success(message)
        
        this.$emit('close-task')
      },
      async sendAmendmentToEvaluation () {
        const response = await this.sendAmendment({
          amendment: this.amendment,
          committee: this.committee,
        })
        
        if (response.data.data.status === 'success') {
          return location.href = `/redirect?url=${encodeURIComponent(location.origin)}&message=${encodeURIComponent(
            response.data.data.message)}`
        }
        
        AlertManager.error(response.data.data.error)
      },
      formatDate: function (dt) {
        return moment(dt).format('DD/MM/YYYY')
      },
      showMessageModal (message, title = 'titulo') {
        this.modalTitle   = title
        this.modalMessage = message

        $('#amednment-extension-message-modal').modal('show')
      },
      async load() {
        this.loading = true;

        const response = await this.getAmendmentDictums({
          amendment: this.amendment,
        });

        this.dictums = response.data;

        this.loading = false;
      },
    },
    computed: {
      ...mapGetters({
        selectedAmendment: 'amendments/selectedAmendment',
      }),
    },
    async mounted () {
      const vm = this

      this.setAmendment(this.amendment)

      autosize(document.getElementById('justification'))

      const $endDate = $('#end_date')
      const $endDateReadOnly = $('#end_date_readonly')
      
      $endDate.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
        onChange (dates, dateStr, instance) {
          vm.amendment.end_date = moment(dates[0]).format('YYYY-MM-DD')
        },
      })
  
      $endDateReadOnly.flatpickr({
        disableMobile: false,
        dateFormat: 'd/m/Y',
        locale: Spanish,
        onChange (dates, dateStr, instance) {
          vm.amendment.end_date = moment(dates[0]).format('YYYY-MM-DD')
        },
      })

      vm.amendmentEndDate = vm.formatDate(vm.amendment.end_date)
      
      if (vm.readonly) {
        $('#amendment-data', vm.$el).
          find('input, :radio, :checkbox, textarea, button').not('.no-readonly').prop('disabled', true)
      }
      
      $(this.$refs.form).validate({
        highlight: function (element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (error, element) {
          error.addClass('invalid-feedback')
          
          if (element[0].type.toLowerCase() === 'radio') {
            element.parents('.form-group').find('.error-bag').html(error)
          }
          else {
            error.insertAfter(element)
          }
        },
        rules: {
          justification: {
            required: true,
          },
          end_date: {
            required: true,
          },
          new_financing: {
            required: true,
          },
        },
        messages: {
          justification: {
            required: 'Escriba la justificación.',
          },
          end_date: {
            required: 'Proporcione la nueva fecha de término',
          },
          new_financing: {
            required: 'Seleccione una opción',
          },
        },
      })
    
      await this.load();
    },
  }
</script>
